import { createContext, useContext, useState } from "react";

const dict = {
  en: {
    "nav.destinations": "Destinations",
    "nav.services": "Services",
    "nav.about": "About",
    "nav.insights": "Insights",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "cta.book": "Book a Private Consultation",
    "cta.bookShort": "Book Consultation",
    "cta.eligibility": "Check Your Eligibility",
    "cta.eligibilityShort": "Check Eligibility",
    "footer.disclaimer":
      "Immistop Global Migration Advisory Private Limited provides advisory and documentation support. Immigration outcomes are never guaranteed; all decisions rest solely with the relevant government authorities. Timelines are indicative and services are subject to eligibility.",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("en");
  const t = (k) => dict[lang]?.[k] ?? dict.en[k] ?? k;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);
export const languages = Object.keys(dict);
